
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"12","height":"12","viewBox":"0 0 306 306"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M94.35 0l-35.7 35.7L175.95 153 58.65 270.3l35.7 35.7 153-153z"}})])
          )
        }
      }
    